import { styled } from '@acko-tech/building-blocks.ui.common';

export const PersonContainer = styled.div`
  border-top: 1px solid #e8e8e8;
  background-color: white;
  position: relative;
  z-index: 2;
`;

export const DescriptionContainer = styled.div`
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LeftDesc = styled.div``;

export const PrimaryText = styled.div`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #121212;
`;

export const SecondaryText = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #4b4b4b;
  margin-top: 4px;
`;

export const RightDesc = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;

export const CounterButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #B0B0B0
  width: 32px;
  height: 32px;
  border-radius: 50%;
  user-select: none;
  color: ${(props) => (props.disabled ? '#E0E0E8' : '#040222')};
  font-size: 1.5rem;
  padding-bottom: 2px;

  @media only screen and (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const Counter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  user-select: none;
  width: 32px;
`;

export const NudgeContainer = styled.div`
  display: flex;
  background: #e2f5ff;
  border-radius: 8px;
  padding: 6px 10px;
  align-items: center;
  margin-top: 8px;
`;

export const NudgeDesc = styled.div`
  margin-left: 10px;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #5b5675;
`;
